// 意大利语言
export const common = {
  cancel:"Annulla",
  confirm:"Conferma",
  country:"Paese"
};
// 订单列表页面
export const orderList = {
  title:"Elenco ordini",
};

// 查询页面
export const cardLoop = {
  cardTitle:"Numero ICCID della scheda SIM",
  cardDesc:"Immettere il numero ICCID della scheda SIM nella casella di immissione.",
  query:"Cerca", //查询按钮
  title:"Piattaforma per schede SIM IOT",
};

// 详情页面
export const cardInfo = {
  title:"Informazioni sulla carta",
  msisdn:"MSISDN：",
  iccid:"ICCID：",
  expiration:"Scadenza：",//过期时间
  status:'stato',
  refresh:"Ricaricare",//刷新
  residualFlow:"FlussoResiduo",//剩余流量
  totalFlow:"Total",//总流量
  used:"Usato",//已使用
  lists:["Usando","NonAttivo","Usato"],//tab切换 1 生效中 2 未生效 3.已失效
  validity:"validità",//套餐有效期
  skuUsed:"Usato",//套餐已用
  skuTotal:"Total",//套餐总量
  recharge:"Ricaricare",//去充值
};

// 选套餐页面
export const cardPlans = {
  title:"Elenco pacchetti",
  buyPlan:"Buy Plan",
  select:"Non selezionato",//未选套餐的提示
  orderList:"Elenco ordini",
  userAgreement:"Accordo utente",
  price:"Prezzo del pacchetto",
  flowCount:"Flusso totale",
  validityTime:"Data di entrata in vigore",
  switchCountryName:"Area utile",
  productDesc:"Descrizione del pacchetto",
  productDescText:"Pagamento anticipato",
  paymentMethod:"Metodo di pagamento",
  checkUserAgreementMsg:"Si prega di controllare l'accordo utente",
  payErrorMsg:"Il numero di conto di raccolta non serve a sostenere i pagamenti in renminbi",
  payBtnText:"Utilizzo di",
};


// 完成支付或取消支付
export const cardPayEnd = {
  title:"Risultati dei pagamenti",
  Details:"Particolari",//返回详情
};

export const country = {
  America:'America',
  HongKong:'HongKong',
  Thailand:'Thailandia',
  Philippines:'Filippine',
  Macao:'Macao'
}

// 位置标签
export const placeTitle = "Paese";
// 国家名称
export const China = "Cina"
export const America = "America"
export const HongKong = "Hong Kong"







